@if (type()) {
  <div>
    @if (type() === 'info') {
      <nb-alert status="info" [innerHTML]="getMessage(message()) | ingsvSanitizeHtml"></nb-alert>
    }
    @if (type() === 'error') {
      <nb-alert status="danger" [innerHTML]="getMessage(message()) | ingsvSanitizeHtml"></nb-alert>
    }
    @if (type() === 'success') {
      <nb-alert status="success" [innerHTML]="getMessage(message()) | ingsvSanitizeHtml"></nb-alert>
    }
  </div>
}
